import { graphql } from "@opensea/graphql"

export const ItemAvatarFragment = graphql(`
  fragment ItemAvatar on Item {
    imageUrl
    tokenId
    backgroundColor
    collection {
      imageUrl
    }
  }
`)
